import React from 'react';
import ReactDOM from 'react-dom';

import MobileNav from './MobileNav';

$(document).ready(() => {
  const mobileNavElement = document.getElementById('mobile-nav-root');
  if (mobileNavElement) {
    const mobileNavData = JSON.parse(mobileNavElement.dataset.items);
    ReactDOM.render(<MobileNav data={mobileNavData} />, mobileNavElement);
  }
});
